import React, { useEffect } from 'react';
import { Fragment, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { CheckIcon, LinkIcon } from '@heroicons/react/24/outline';

export default function PdfEmbed({ base64, open, setOpen, orderConfirmation, isAirCert = false }) {
    // scroll to top of page
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog as='div' className='relative z-20' onClose={setOpen}>
                <Transition.Child
                    as={Fragment}
                    enter='ease-out duration-300'
                    enterFrom='opacity-0'
                    enterTo='opacity-100'
                    leave='ease-in duration-200'
                    leaveFrom='opacity-100'
                    leaveTo='opacity-0'
                >
                    <div className='fixed inset-0 bg-gray-500 bg-opacity-90 transition-opacity' />
                </Transition.Child>

                <div className='overflow-y-auto fixed inset-0 z-10'>
                    <div className='flex justify-center items-end p-4 text-center sm:items-center sm:p-0'>
                        <Transition.Child
                            as={Fragment}
                            enter='ease-out duration-300'
                            enterFrom='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
                            enterTo='opacity-100 translate-y-0 sm:scale-100'
                            leave='ease-in duration-200'
                            leaveFrom='opacity-100 translate-y-0 sm:scale-100'
                            leaveTo='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
                        >
                            <Dialog.Panel className='overflow-hidden relative px-4 pt-5 pb-4 text-left bg-white rounded-lg shadow-xl transition-all transform sm:my-8 sm:w-full sm:max-w-5xl sm:p-6'>
                                <div>
                                    {orderConfirmation && (
                                        <div className=''>
                                            <div className='flex justify-center items-center mx-auto w-12 h-12 bg-green-100 rounded-full'>
                                                <CheckIcon className='w-6 h-6 text-green-600' aria-hidden='true' />
                                            </div>
                                            <div className='mt-3 text-center sm:mt-5'>
                                                <Dialog.Title
                                                    as='h3'
                                                    className='text-lg font-medium leading-6 text-gray-900'
                                                >
                                                    Order Confirmation
                                                </Dialog.Title>
                                                <div className='mt-2'>
                                                    <p className='text-sm text-gray-500'>
                                                        Your order has been placed. Please check your email for a
                                                        confirmation.
                                                    </p>
                                                    {isAirCert && (
                                                        <p className='text-sm text-red-600'>
                                                            Please validate that the Purchase Order was created successfully.
                                                        </p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <div className='mt-3 text-center sm:mt-5'>
                                        <div className='shadow'>
                                            <embed
                                                className='w-full pdfembedheight'
                                                src={`data:application/pdf;base64,${base64}`}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='mt-6'>
                                    <button
                                        type='button'
                                        className='justify-center px-3 py-1.5 mx-auto w-1/2 text-sm font-medium text-white rounded-md border border-transparent shadow-sm bg-blue-primary hover:bg-white hover:text-blue-primary focus:outline-none focus:ring-2 focus:ring-blue-primary focus:ring-offset-2 sm:text-sm'
                                        onClick={() => {
                                            setOpen(false);
                                        }}
                                    >
                                        Go back
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}
